import script from "./StoriesMenuSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./StoriesMenuSlider.vue?vue&type=script&setup=true&lang=js"

import "./StoriesMenuSlider.vue?vue&type=style&index=0&id=6e82bb47&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e82bb47"]])

export default __exports__